import { nullSafeGet, nullSafeGetOrElse } from './DataAccessUtils';
import { SUPPLIER_RELATIONSHIP_STATUSES } from './DataConstants';

export const isSelfManagedSupplierEmailPromptEnabled = (companyConfig: any): boolean =>
	nullSafeGetOrElse(
		'config.workOrder.allowSelfManagedSupplierInvitationDuringWorkOrderCreation',
		companyConfig,
		false
	);

export const shouldPromptForSelfManagedSupplierEmail = (
	companyConfig: any,
	supplierFacility: any,
	supplierRelationship: any
): boolean => {
	if (!isSelfManagedSupplierEmailPromptEnabled(companyConfig)) {
		return false;
	}
	const relationshipStatus = nullSafeGet('relationshipStatus', supplierRelationship);
	return relationshipStatus === SUPPLIER_RELATIONSHIP_STATUSES.SELF_MANAGED;
};

export const shouldShowSelfManagedSupplierInviteBanner = (
	companyConfig: any,
	workOrder: any,
	supplierRelationship: any
): boolean => {
	if (!isSelfManagedSupplierEmailPromptEnabled(companyConfig)) {
		return false;
	}
	const supplierFacility = nullSafeGet('supplierFacility', workOrder);
	if (!supplierFacility) {
		return false;
	}
	const relationshipStatus = nullSafeGet('relationshipStatus', supplierRelationship);
	return relationshipStatus === SUPPLIER_RELATIONSHIP_STATUSES.SELF_MANAGED;
};
